const types = require('constants/actionTypes');

const letterSelected = ({ letter }) => ({
    type: types.GLOSSARY_LETTER_SELECTED,
    payload: { letter },
});

module.exports = letterSelected;
